/**
 * @module Passage
 */
'use strict';

var Route = require('./lib/route');


module.exports = Route;


/*****************
 ** WEBPACK FOOTER
 ** ./~/route-parser/index.js
 ** module id = 345
 ** module chunks = 1
 **/